import { fromJS } from 'immutable';
import { SetUserLogin, ApiUrl2, SetUserLogout, SetUserMenu } from '../../helper/HelperAuth'
import doFetch from '../../infra/helper/fetchHelper'
import {
    keyIsLoggedIn,
    GlobalLoading
} from '../constants';

export default (username, password) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    var param = username+':'+password;
    param = btoa(param);
    
    const url = ApiUrl2 + 'user-login';
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': 'Basic '+param,
        }
    };
    
    const response = await doFetch(url,argument, true);

    if(response.ok){
        var users = await response.json();
        let userLogin = users.users[0];
        var loggedInUser = fromJS(userLogin);

        const argument2 = {  
            method: 'POST',
            headers : {
                'Content-Type':'application/json',
                'Authorization': loggedInUser.get('token'),
            },
            body : JSON.stringify({
                "query":{
                    "privilege-id": loggedInUser.get('privilege-id'),
                }       
            })
        };  

        var response2 = await doFetch(ApiUrl2 + 'config-accessmodule-list',argument2, true);
        if(response2.ok){
            var data = fromJS({});
            data = fromJS(await response2.json());
            data = data.get('query-result');
            //final
            SetUserLogin(loggedInUser, data);
        } 

        dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
        dispatch({ type: keyIsLoggedIn, isLoggedIn: true });
        return response2;
    }else{
        SetUserLogout();
        dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
        dispatch({ type: keyIsLoggedIn, isLoggedIn: true });
        return response;
    }
    
    
};